import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { LogOut, reset } from "../features/authSlice";
import { IoLogOut, IoPersonCircleOutline } from "react-icons/io5";
import { useState, useEffect } from "react";

const Navbar = () => {
  const [url, setUrl] = useState("");
  const [companyname, setCompanyName] = useState("");
  const [msg, setMsg] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  function toggleBurgerMenu() {
    document.querySelector('.navbar-menu').classList.toggle('is-active');
  }

  // Access the environment variables
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    const getCompany = async () => {
        try {
            //get data sales contract
            const response = await axios.get(`${API_BASE_URL}/companies`,
              {
                headers: {
                    'X-API-Key': API_KEY
                },
              }
            );  
            setCompanyName(response.data[0].name);
            setUrl(response.data[0].url);
        } catch (error) {
            console.error(error);
            if (error.response) {
              setMsg(error.response.data.msg);
            }
        }
    };
    getCompany();
  });

  const logout = () => {
    dispatch(LogOut());
    dispatch(reset());
    navigate("/");
  };

  return (
    <div>
      <nav className="navbar is-fixed-top has-shadow" role="navigation" aria-label="main navigation">
        <div className="navbar-brand">
          <NavLink to="/dashboard" className="navbar-item">
            <img src={url} width="40" alt="company logo"/>
            <p className="ml-2 has-text-link is-uppercase has-text-weight-bold">{companyname}</p>
          </NavLink>
          <a role="button" onClick={toggleBurgerMenu} className="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasic">
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>
        <div id="navbarBasic" className="navbar-menu">
          {user && user.role === "user" && (
          <div className="navbar-start">
            <div className="navbar-item has-dropdown is-hoverable">
              <a className="navbar-link">
                Support
              </a>
              <div className="navbar-dropdown">
                <NavLink to="/mytickets" className="navbar-item">
                  My Ticket
                </NavLink>
                <NavLink to="/myhistories" className="navbar-item">
                  My Repair History
                </NavLink>
              </div>
            </div>
          </div>
          )}
          {user && (
          <div className="navbar-end">
              <div className="navbar-item has-dropdown is-hoverable">
                <a className="navbar-link">
                  <strong>{user.name}</strong>
                </a>
                <div className="navbar-dropdown is-right">
                  <NavLink to={`/profiles/edit/${user.uuid}`} className="navbar-item">
                   <IoPersonCircleOutline />&nbsp;Profile
                  </NavLink>
                  <a onClick={logout} className="navbar-item has-text-danger">
                    <IoLogOut />&nbsp;Logout
                  </a>
                </div>
              </div>
              
          </div>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Navbar;
